(() => {
  const triggers = '[name="buy-prescription"], [data-chat-trigger], a[href="#chat-trigger"], [name="chat-basket"]';
  let pending = false;

  // Inbox now exposes <shopify-chat>.show(); its conversation lives in a
  // cross-origin iframe, so theme code cannot click instant-answer buttons.
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest?.(triggers);
    if (!trigger) return;
    event.preventDefault();
    if (pending) return;
    pending = true;

    let status = document.getElementById('prescription-chat-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'prescription-chat-status';
      status.setAttribute('role', 'status');
    }
    trigger.insertAdjacentElement('afterend', status);
    status.textContent = 'Opening chat…';
    trigger.setAttribute('aria-busy', 'true');

    try {
      // The app embed and its custom-element definition can arrive late.
      const deadline = Date.now() + 15000;
      while (Date.now() < deadline) {
        const chat = document.querySelector('shopify-chat');
        if (typeof chat?.show === 'function') {
          chat.show();
          status.textContent = '';
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, 200));
      }
      throw new Error('Inbox did not load');
    } catch (error) {
      status.textContent = 'Chat could not open. Please refresh the page and try again, or contact us.';
    } finally {
      trigger.removeAttribute('aria-busy');
      pending = false;
    }
  });
})();
